import { Component, OnInit } from '@angular/core';
import { ApplicationContextService }         from './app-context.service';


@Component({
 //   moduleId: module.id,
  selector: 'quicklink-cmp',
  templateUrl: './quicklink.component.html',
  styleUrls: ['./quicklink.component.css']
})
export class QuickLinkComponent implements OnInit {
 constructor(
    private appContextService: ApplicationContextService) { }

  ngOnInit(): void {
    ;

  }


}
